export default __webpack_public_path__ + "static/media/goalActive.b557b40f.svg";